"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_1 = tslib_1.__importDefault(require("vue"));
const siteText_1 = tslib_1.__importDefault(require("../mixins/siteText"));
const sitetext_1 = require("../filters/sitetext");
const userTelemetry_1 = require("../api/userTelemetry");
exports.default = vue_1.default.extend({
    name: 'forgot-links',
    mixins: [siteText_1.default],
    data: () => {
        return {
            FUFPToggle: false,
        };
    },
    filters: {
        sitetext: sitetext_1.siteTextFilter,
    },
    computed: {
        isMobile() {
            return this.$store.getters.isMobile;
        },
        showForgotPasswordLink() {
            return this.$store.getters.displayForgotPasswordLink;
        },
        forgotUsernameUrl() {
            return `${this.$store.state.configuration.baseUrl}ForgotUsername`;
        },
        showForgotUsernameLink() {
            return this.$store.getters.displayForgotUsernameLink;
        },
        forgotPasswordUrl() {
            return `${this.$store.state.configuration.baseUrl}ForgotPassword`;
        },
        useIrisSheetForFUFP() {
            return this.isMobile && this.showForgotUsernameLink && this.showForgotPasswordLink;
        },
        FUFPText() {
            let linkText = '';
            switch (true) {
                case this.showForgotUsernameLink && this.showForgotPasswordLink:
                    linkText = this.getSiteText('UsernameAndPassword.Link.Forgot.UsernameAndPassword');
                    break;
                case this.showForgotUsernameLink:
                    linkText = this.getSiteText('UsernameAndPassword.Link.Forgot.Username');
                    break;
                case this.showForgotPasswordLink:
                    linkText = this.getSiteText('UsernameAndPassword.Link.Forgot.Password');
                    break;
            }
            if (this.isMobile) {
                let href = '';
                switch (true) {
                    case this.useIrisSheetForFUFP:
                        href = ' tabindex="0"';
                        break;
                    case this.showForgotUsernameLink:
                        href = ` href="${this.forgotUsernameUrl}"`;
                        break;
                    case this.showForgotPasswordLink:
                        href = ` href="${this.forgotPasswordUrl}"`;
                        break;
                }
                linkText = `<a${href} class="forgotLinks_anchor">${linkText.replace(/{linku}|{linkp}/ig, '')}</a>`;
            }
            else {
                let uCount = 0;
                let pCount = 0;
                linkText = linkText.replace(/{linku}|{linkp}/ig, (match) => {
                    let count;
                    if (match.toLowerCase() === '{linku}')
                        count = ++uCount;
                    else
                        count = ++pCount;
                    if (count % 2 === 0)
                        return '</a>';
                    return `<a href="${match.toLowerCase() === '{linku}' ? this.forgotUsernameUrl : this.forgotPasswordUrl}">`;
                });
            }
            return linkText;
        },
        isCypress() {
            return this.$store.state.isCypress;
        },
    },
    methods: {
        mobileForgotUsernameOrPassword() {
            this.FUFPToggle = true;
            // Workaround for the iris-sheet close button not setting a type on the button
            // Unfortunately, the button isn't rendered until after mounted() has finished, so have to do it here
            let irisSheetCloseButton = document.querySelector('.forgotLinks [aria-label="close"]');
            if (irisSheetCloseButton) {
                irisSheetCloseButton.setAttribute('type', 'button');
            }
        },
        async handleClick(event) {
            const href = event.target.getAttribute('href');
            if (href === null)
                return;
            if (href === this.forgotUsernameUrl) {
                await userTelemetry_1.telemetry.custom({
                    workflowName: userTelemetry_1.workflowName.retail_registration,
                    stepType: userTelemetry_1.stepType.entry,
                    stepName: userTelemetry_1.stepName.login,
                    action: userTelemetry_1.userAction.forgot_username_clicked,
                });
            }
            else if (href === this.forgotPasswordUrl) {
                await userTelemetry_1.telemetry.custom({
                    workflowName: userTelemetry_1.workflowName.retail_registration,
                    stepType: userTelemetry_1.stepType.entry,
                    stepName: userTelemetry_1.stepName.login,
                    action: userTelemetry_1.userAction.forgot_password_clicked,
                });
            }
            if (this.isCypress)
                return;
            document.location.href = href;
        },
    },
});
